import PropTypes from 'prop-types';
import React from 'react';
import { RowDefinition, ColumnDefinition } from 'griddle-react';
import {
  ButtonToolbar,
  Button,
} from 'react-bootstrap';
import { EVENT_NAMES } from './EventStyles';
import EventIcon from './EventIcon';
import StyledGriddle from '../../../components/StyledGriddle';
import { fullDate, shortDate } from '../../../core/date';


const EventType = ({ value }) => <EventIcon eventType={value} />;

function formatTime(duration) {
  return duration.substring(0, duration.lastIndexOf(':'));
}

function formatDate(event) {
  if (event.event_type === 'stay') {
    return `${shortDate(event.start)} - ${fullDate(event.end)}`;
  }
  return fullDate(event.start);
}
function formatRelatedEvent(event, events, parent, filter) {
  if (filter[event.group_name]) {
    return;
  }
  let location;
  let name;
  if (event.place) {
    location = `${event.place.city}, ${event.place.state}`;
  }
  name = `${event.group_name} @ ${event.place.city} ${event.place.state}`;
  if (event.bids.hotel) {
    name = `${event.group_name} @ ${event.bids.hotel.name}`;
    location = `${event.bids.hotel.city}, ${event.bids.hotel.state}`;
  }
  const dates = formatDate(event);
  events.push({
    id: parent.id,
    date: dates,
    name,
    event_type: event.event_type,
    location,
    driveTime: formatTime(parent.duration_to_next),
    image: event.event_type,
    notes: event.notes,
  });
}

function formatEvent(event, events, filter) {
  if (event.event_type === 'stay') {
    const relatedEvents = event.related_group_events;
    for (let i = 0, len = relatedEvents.length; i < len; i++) {
      formatRelatedEvent(relatedEvents[i], events, event, filter);
    }
  } else {
    if (filter[event.event_type]) {
      return;
    }
    const dates = formatDate(event);
    let location;
    if (event.place) {
      location = `${event.place.city}, ${event.place.state}`;
    }
    const name = event.name ? event.name : EVENT_NAMES[event.event_type];
    events.push({
      id: event.id,
      date: dates,
      name,
      event_type: event.event_type,
      location,
      image: event.event_type,
      notes: event.notes,
    });
  }
}

class TourRouteTable extends React.Component {
  render() {
    const Toolbar = ({ value }) => (
      <ButtonToolbar>
        <Button name="Edit" data-item={value} onClick={this.props.showEvent}>
          <span className="fa-stack fa-lg" aria-hidden="true">
            <i className="fa fa-square-o fa-stack-2x" />
            <i className="fa fa-pencil" />
          </span>
        </Button>
      </ButtonToolbar>);

    const route = [];
    this.props.tourStops.forEach((event) => {
      formatEvent(event, route, this.props.filter);
      if (event.events) {
        for (let i = 0, len = event.events.length; i < len; i += 1) {
          formatEvent(event.events[i], route, this.props.filter);
        }
      }
    });

    return (
      <StyledGriddle
        data={route}
      >
        <RowDefinition>
          <ColumnDefinition id="image" title=" " customComponent={EventType} />
          <ColumnDefinition id="date" title="Date" />
          <ColumnDefinition id="name" title="Name" />
          <ColumnDefinition id="location" title="Location" />
          <ColumnDefinition id="driveTime" title="Drive Time" />
          <ColumnDefinition id="notes" title="Notes" />
          <ColumnDefinition id="id" title=" " customComponent={Toolbar} />
        </RowDefinition>
      </StyledGriddle>
    );
  }
}
TourRouteTable.propTypes = {
  tourStops: PropTypes.arrayOf(PropTypes.object).isRequired,
  showEvent: PropTypes.func.isRequired,
  filter: PropTypes.object.isRequired,
};


export default TourRouteTable;



// WEBPACK FOOTER //
// src/routes/tours/components/TourRouteTable.js